export const GET_DOCUMENT_DATA = 'GET_DOCUMENT_DATA';
export const GET_DOCUMENT_META = 'GET_DOCUMENT_META';
export const FETCH_DOCUMENT_META_START = 'FETCH_DOCUMENT_META_START';
export const FETCH_DOCUMENT_META_SUCCESS = 'FETCH_DOCUMENT_META_SUCCESS';
export const FETCH_DOCUMENT_META_ERROR = 'FETCH_DOCUMENT_META_ERROR';
export const FETCH_DOCUMENT_FILE_ERROR = 'FETCH_DOCUMENT_FILE_ERROR';
export const FETCH_DOCUMENT_FILE_SUCCESS = 'FETCH_DOCUMENT_FILE_SUCCESS';
export const FETCH_TRANSLATION = 'FETCH_TRANSLATION';
export const GET_TRANSLATION_FILE = 'GET_TRANSLATION_FILE';
export const FETCH_TRANSLATION_ERROR = 'FETCH_TRANSLATION_ERROR';
